module.exports = __webpack_public_path__ + "img/img4.aa049323.png";